import React from 'react';
import { Radio } from "@chakra-ui/react";
import {
  
  RadioGroupControl,
  
} from "formik-chakra-ui";

function RadioInput(props) {
    const {name,type,inputValue,title,placeholder} = props
    const [value, setValue] = React.useState('')
    const handleChange = (event) => setValue(event.target.value)
    return(
        <>
            <div className="field_section">
                
                 <RadioGroupControl inputProps={{...props.inputProps,placeholder}} name={name} label={title}>
            <Radio value="1">Smart Message</Radio>
            <Radio value="2">SMS</Radio>
            <Radio value="3">WhatsApp</Radio>
          </RadioGroupControl>
                
            </div>
            
        </>
    );
}

export default RadioInput;